import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {connect} from 'react-redux';
import {Modal} from 'antd';
import ListMenu from "..";
import BankAccountActions from 'bukku/redux/BankAccount/actions';
import { SubscriptionCheck } from '../../Access/helper/subscription/SubscriptionCheck';
import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';
import { BankFeedConnectionStatus } from '../../../containers/AppPage/Bank/BankFeedConnect/enums/BankFeedConnectionStatus';
import BankFeedActions from 'bukku/redux/BankFeed/actions';
import { PermissionKey } from '../../Access/helper/permission/enum/PermissionKey';
import { PermissionV2 } from '../../Access/helper/permission/enum/PermissionV2';

const {
    archive: archiveAccount,
    delete: deleteAccount,
} = BankAccountActions;
const {
    syncBankFeed,
} = BankFeedActions;

class BankAccountListMenu extends Component {
    hasManualReconSubscription = SubscriptionCheck
        .withKeys(SubscriptionScopeKey['BANK.RECONCILIATION.MANUAL']).hasSubscriptionTo();

    hasSmartReconSubscription = SubscriptionCheck
        .withKeys(SubscriptionScopeKey['BANK.RECONCILIATION.AUTO']).hasSubscriptionTo();

    toggleActivation = record => {
        const {
            archiveAccount,
        } = this.props;
        const isArchived = record.is_archived;

        Modal.confirm({
            title: (isArchived ? t`Activate Bank Account` : t`Deactivate Bank Account`),
            content: isArchived ?
                t`Do you really want to activate bank account ${record.name}?` :
                t`Do you really want to deactivate bank account ${record.name}?`,
            onOk() {
                archiveAccount(record.id, {
                    is_archived: !isArchived,
                });
            },
            onCancel() {},
            okText: (isArchived ? t`Activate` : t`Deactivate`),
            cancelText: t`Cancel`,
        });
    };

    onDelete = record => {
        const {
            deleteAccount,
        } = this.props;

        Modal.confirm({
            title: t`Delete Account`,
            content: t`Do you really want to PERMANENTLY delete the bank account ${record.name}?`,
            onOk() {
                deleteAccount(record.id);
            },
            onCancel() {},
            okText: t`Delete`,
            cancelText: t`Cancel`,
        });
    };

    // syncAccountBankFeeds = record => {
    //     const {
    //         syncBankFeed,
    //     } = this.props;
    //     syncBankFeed(record.bank_feed_id);
    // };

    getBankingIntegrationActions = record => {
        const {
            // redux
            bankFeeds,
        } = this.props;

        const items = [];
        const bankFeed = bankFeeds.find(feed => feed.id === record.bank_feed_id) || {};
        const {
            status: bankFeedStatus,
        } = bankFeed;

        if (record?.bank_feed_id) {
            switch (bankFeedStatus) {
                case BankFeedConnectionStatus.CONNECTED:
                    items.push({
                        key: 'transactions',
                        label: t`View Transactions`,
                        url: `/bank/feeds/${record.bank_feed_id}/accounts/${record.id}/transactions`,
                        permission: PermissionKey.bank_feed,
                        requiredLevel: PermissionV2.read,
                    });
                    // items.push({
                    //     key: 'sync',
                    //     label: t`Sync Bank Feeds`,
                    //     action: () => this.syncAccountBankFeeds(record),
                    // });
                    break;
                default:
                    break;
            }
        }
        return items;
    };

    getItems = () => {
        const { record } = this.props;
        const items = [];

        if (record.is_archived) {
            items.push({
                key: 'activate',
                label: t`Activate`,
                action: () => this.toggleActivation(record),
                isUpdate: true,
            });
            items.push({
                key: 'view',
                label: t`View`,
                url: `/bank/accounts/${record.id}`,
            });
        }
        else {
            items.push({
                key: 'reconcile',
                label: t`Reconcile`,
                url: `/bank/accounts/${record.id}/reconcile`,
                overrideHasSubscription: this.hasManualReconSubscription || this.hasSmartReconSubscription,
            });
            items.push({
                key: 'view',
                label: t`View`,
                url: `/bank/accounts/${record.id}`,
            });
            items.push(...this.getBankingIntegrationActions(record));
            items.push({
                key: 'deactivate',
                label: t`Deactivate`,
                disabled: record.is_locked,
                action: () => this.toggleActivation(record),
                isUpdate: true,
            });
        }
        items.push({
            key: 'delete',
            label: t`Delete`,
            disabled: !record.is_deletable,
            action: () => this.onDelete(record),
            isDelete: true,
        });
        return items;
    };

    render() {
        return (
            <ListMenu items={this.getItems()} />
        );
    }
}
export default connect(state => ({
    bankFeeds: state.BankFeed.bankFeeds,
}), {
    archiveAccount,
    deleteAccount,
    syncBankFeed,
})(BankAccountListMenu);
